import { Box } from "@mui/material";
import { CustomStyles, getStyles } from "src/styles/theme";
import defaultStyles, { StylesClasses } from "./styles";

type ViewFormProps = {
  customStyles?: CustomStyles<StylesClasses>;
  label: string;
  value?: string | number;
  date?: string;
  labelStyles?: React.CSSProperties;
  valueStyles?: React.CSSProperties;
  tableValue?: React.ReactNode;
};

const ViewForm = ({
  label,
  value,
  customStyles,
  date,
  labelStyles,
  valueStyles,
  tableValue,
}: ViewFormProps) => {
  const styles = getStyles<StylesClasses>(defaultStyles, customStyles);
  return (
    <Box {...styles("wrapper")}>
      <Box {...styles("label")} style={labelStyles}>
        {label} :
      </Box>
      <Box {...styles("value")} style={valueStyles}>
        {!!value ? value : "-"}
      </Box>
      {date && <Box {...styles("date")}>{!!date ? date : "-"}</Box>}
      {tableValue && (
        <Box {...styles("date")}>{!!tableValue ? tableValue : "-"}</Box>
      )}
    </Box>
  );
};

export default ViewForm;
